import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import WhyChooseUs from "../components/WhyChooseUs";
import PopularTours from "../components/PopularTours";
import Activities from "../components/Activities";
// import Banner from "../components/Banner";
import Destinations from "../components/Destinations";
// import Articles from "../components/Articles";
import Partners from "../components/Partners";
import Footer from "../components/Footer";
import Reviews from '../components/Reviews';

const Home = () => {
  document.title = "Home | Song & Stark Tours";
  return (
    <>
    <div className="home-container"></div>
      <div className="container-full">
        <div className="header-container">
          <Header />
          <Hero />
        </div>
      </div>
      <div className="container">
      <WhyChooseUs />
        <div className="popular-tours-title">
          <h2>Popular tours</h2>
        </div>    
        <PopularTours />
        </div>
        <div className="container-full">
        <Destinations />
        </div>  
        <div className="container">
        <Activities />
        {/* <Banner /> */}
     <Reviews />
        <Partners />
        {/* <Articles /> */}
      </div>    
      
      <div className="container-full">
        <Footer />
      </div>
    </>
  );
};

export default Home;
